import PropTypes from "prop-types";
import React from "react";
import { IconError } from "../../";
/**
 * The `ErrorMessage` component provides the iconography and styling necessary to comply
 * with our error messaging visual standards.
 */

import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";

function ErrorMessage(_ref) {
  let {
    children,
    noErrorIcon,
    label,
    errorText,
    id,
    message,
    visuallyHiddenStyle,
    ariaHidden
  } = _ref;
  return _jsxs(React.Fragment, {
    children: [!noErrorIcon && _jsx(IconError, {
      size: "xsmall",
      spacing: {
        r: 0.5
      },
      display: "block"
    }), _jsxs("div", {
      "aria-hidden": ariaHidden || null,
      id: id,
      children: [_jsxs("span", {
        css: visuallyHiddenStyle,
        children: [label, " ", errorText]
      }), message]
    }), children]
  });
}

ErrorMessage.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Determines whether the error message should be hidden from ATs. */
  ariaHidden: PropTypes.bool,

  /** This is what will be displayed inside the component. */
  children: PropTypes.node,

  /** Prefix for error message. */
  errorText: PropTypes.string,

  /** The id passed to the node. */
  id: PropTypes.string,

  /** The label of the Field. (A11y requirement) */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /** The error content to be shown as the inline message. */
  message: PropTypes.string,

  /** Determines whether the error icon should be displayed or not. */
  noErrorIcon: PropTypes.bool,

  /** Visually hidden style. */
  visuallyHiddenStyle: PropTypes.shape()
} : {};
ErrorMessage.defaultProps = {
  ariaHidden: false,
  children: null,
  errorText: null,
  id: "",
  label: null,
  message: null,
  noErrorIcon: false,
  visuallyHiddenStyle: null
};
export default ErrorMessage;